import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

export const debriefTheme = createTheme({
    typography: {
        fontSize: 12,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        h1: {
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        },
    },
    palette: {
        secondary: grey,
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'initial',
                    fontWeight: 600,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1E374F',
                    color: '#FFFFFF',
                    marginBottom: '1rem',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    padding: '16px 20px',
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                },
            },
        },
    },
});

const DebriefThemeProvider = (props: React.PropsWithChildren) => {
    return <ThemeProvider theme={debriefTheme}>{props.children}</ThemeProvider>;
};

export default DebriefThemeProvider;
